import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const CloudSunIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 28 28",
  path: (
    <>
      <Path
        d="M12.2502 1.75V3.61667M4.20016 11.6667H2.3335M6.35989 5.7766L5.03996 4.45667M18.1416 5.7766L19.4615 4.45667M22.1668 11.6667H20.3002M7.58358 11.6668C7.58358 9.08942 9.67292 7.00008 12.2503 7.00008C14.0073 7.00008 15.5375 7.97108 16.3336 9.40573M7.00016 25.6667C4.42283 25.6667 2.3335 23.5773 2.3335 21C2.3335 18.4227 4.42283 16.3333 7.00016 16.3333C7.54171 16.3333 8.06172 16.4256 8.54532 16.5952C9.38087 14.3962 11.508 12.8333 14.0002 12.8333C16.4923 12.8333 18.6195 14.3962 19.455 16.5952C19.9386 16.4256 20.4586 16.3333 21.0002 16.3333C23.5775 16.3333 25.6668 18.4227 25.6668 21C25.6668 23.5773 23.5775 25.6667 21.0002 25.6667C15.5865 25.6667 11.5259 25.6667 7.00016 25.6667Z"
        stroke="#AEBFFC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export { CloudSunIcon };
